import React from "react";
import { formatMessage } from "lib/globalize-util";

const listOfSpecifications = [
    "XLS, XLSX, or CSV only",
    "Products not included in your file will remain as-is.",
    "For any product you are updating, be sure to include all sizes in your file.",
    "Maximum file size: 2MB",
];

export const useFileSpecificationsAndTipsForUpload = () => {
    return {
        title: formatMessage("Upload tips & specifications:"),
        items: listOfSpecifications.map((spec, index) => <li key={`${spec}-${index}`}>{formatMessage(spec)}</li>),
    };
};
